import fetchInterceptor , {FetchOptions} from "../../../utils/fetchInterceptor ";
import { newsEndpoints } from "../apiEndPoints";
import { header } from "../../../context/constant";

const AddNewsAPI =  async (newsData: FormData) => {
  const url = newsEndpoints.add();
  const options: FetchOptions = {
    method: "POST",
    body: newsData, // Pass the FormData object directly
  };
  return fetchInterceptor(url, options);
};

export default AddNewsAPI;